// ==============================================================================
// Story 001: The Silent Piano (Corrected Version)
// ==============================================================================

const STORY_DATA = [
  {
    title: "Part 1: The Graveyard of Time",
    rubyText: [
      { w: "The", r: "ザ" },
      { w: "music", r: "ミュージック" },
      { w: "room", r: "ルーム", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "old", r: "オールド" },
      { w: "building", r: "ビルディング", s: true },
      { w: "is", r: "イズ" },
      { w: "like", r: "ライク", s: true },
      { w: "a", r: "ア" },
      { w: "graveyard", r: "グレイブヤード" },
      { w: "of", r: "オブ" },
      { w: "time.", r: "タイム" , s: true },
      { w: "In", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "corner,", r: "コーナー", s: true },
      { w: "there", r: "ゼア" },
      { w: "is", r: "イズ", s: true },
      { w: "an", r: "アン" },
      { w: "old", r: "オールド" },
      { w: "piano.", r: "ピアノ" , s: true },
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "covered", r: "カバード", s: true },
      { w: "with", r: "ウィズ" },
      { w: "dust.", r: "ダスト" , s: true },
      { w: "Teachers", r: "ティーチャーズ" },
      { w: "say,", r: "セイ", s: true },
      { w: "'We", r: "ウィ" },
      { w: "will", r: "ウィル" },
      { w: "throw", r: "スロー" },
      { w: "it", r: "イット" },
      { w: "away", r: "アウェイ", s: true },
      { w: "soon.'", r: "スーン" , s: true },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "like", r: "ライク", s: true },
      { w: "this", r: "ディス" },
      { w: "piano.", r: "ピアノ", s: true  },
      { w: "I", r: "アイ" },
      { w: "have", r: "ハブ", s: true },
      { w: "no", r: "ノー" },
      { w: "passion.", r: "パッション" , s: true },
      { w: "I", r: "アイ" },
      { w: "just", r: "ジャスト" },
      { w: "live", r: "リブ", s: true },
      { w: "day", r: "デイ" },
      { w: "by", r: "バイ" },
      { w: "day.", r: "デイ", s: true  },
    ],
    en: "The music room in the old building is like a graveyard of time. In the corner, there is an old piano. It is covered with dust. Teachers say, 'We will throw it away soon.' I am like this piano. I have no passion. I just live day by day.",
    ja: "旧校舎の音楽室は、まるで「時間の墓場」のようです。\n隅には古いピアノが置かれています。それは埃に覆われています。\n先生たちは「もうすぐ処分するだろう」と言います。\n僕はこのピアノに似ています。情熱もなく、ただその日暮らしをしているだけだからです。",
    learning: {
      vocab: [
        { word: "graveyard", mean: "墓場" },
        { word: "throw away", mean: "捨てる" },
        { word: "passion", mean: "情熱" },
      ],
      grammar: {
        title: "前置詞の like",
        desc: "「～が好き」ではなく、「～のような」という意味で使われています。",
        key: "...is like a graveyard...",
      },
    },
    color: "bg-stone-200",
    accent: "text-stone-600",
    mood: { rate: 0.9, pitch: 0.8 },
    image: "images/001/01.jpg",
    startTime: 0,
  },
  {
    title: "Part 2: The Transparent Wall",
    rubyText: [
      { w: "In", r: "イン" },
      { w: "autumn,", r: "オータム", s: true },
      { w: "a", r: "ア" },
      { w: "new", r: "ニュー" },
      { w: "student", r: "スチューデント" },
      { w: "comes.", r: "カムズ", s: true },
      { w: "Her", r: "ハー" },
      { w: "name", r: "ネイム", s: true },
      { w: "is", r: "イズ" },
      { w: "Aya.", r: "アヤ" , s: true},
      { w: "She", r: "シー" },
      { w: "is", r: "イズ", s: true },
      { w: "very", r: "ベリー" },
      { w: "quiet.", r: "クワイエット" , s: true},
      { w: "She", r: "シー" },
      { w: "always", r: "オールウェイズ" },
      { w: "looks", r: "ルックス", s: true },
      { w: "at", r: "アット" },
      { w: "the", r: "ザ" },
      { w: "sky", r: "スカイ", s: true },
      { w: "alone.", r: "アローン" , s: true},
      { w: "There", r: "ゼア" },
      { w: "is", r: "イズ", s: true },
      { w: "a", r: "ア" },
      { w: "transparent", r: "トランスペアレント" },
      { w: "wall", r: "ウォール", s: true },
      { w: "around", r: "アラウンド" },
      { w: "her.", r: "ハー" , s: true},
      { w: "No", r: "ノー" },
      { w: "one", r: "ワン", s: true },
      { w: "touches", r: "タッチズ" },
      { w: "her.", r: "ハー" , s: true},
      { w: "The", r: "ザ" },
      { w: "air", r: "エア" },
      { w: "around", r: "アラウンド" },
      { w: "her", r: "ハー", s: true },
      { w: "is", r: "イズ" },
      { w: "always", r: "オールウェイズ" },
      { w: "calm.", r: "カーム" , s: true},
    ],
    en: "In autumn, a new student comes. Her name is Aya. She is very quiet. She always looks at the sky alone. There is a transparent wall around her. No one touches her. The air around her is always calm.",
    ja: "秋、新しい生徒がやって来ました。名前はアヤ。\n彼女はとても静かです。いつも一人で空を見上げています。\n彼女の周りには「透明な壁」があります。\n誰も彼女に触れません。彼女の周りの空気は、いつも凪いでいます。",
    learning: {
      vocab: [
        { word: "transparent", mean: "透明な" },
        { word: "wall", mean: "壁" },
        { word: "calm", mean: "穏やかな" },
      ],
      grammar: {
        title: "There is ...",
        desc: "「～がある／いる」という意味です。単数の名詞が続きます。",
        key: "There is a transparent wall...",
      },
    },
    color: "bg-sky-100",
    accent: "text-sky-600",
    mood: { rate: 1.0, pitch: 1.1 },
    image: "images/001/02.jpg",
    startTime: 20,
  },
  {
    title: "Part 3: The Resurrected Sound",
    rubyText: [
      { w: "One", r: "ワン" },
      { w: "evening,", r: "イブニング", s: true },
      { w: "I", r: "アイ" },
      { w: "hear", r: "ヒア" },
      { w: "a", r: "ア" },
      { w: "sound", r: "サウンド", s: true },
      { w: "from", r: "フロム" },
      { w: "the", r: "ザ" },
      { w: "music", r: "ミュージック" },
      { w: "room.", r: "ルーム" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ", s: true },
      { w: "the", r: "ザ" },
      { w: "old", r: "オールド" },
      { w: "piano.", r: "ピアノ" , s: true},
      { w: "But", r: "バット", s: true },
      { w: "the", r: "ザ" },
      { w: "sound", r: "サウンド" },
      { w: "is", r: "イズ" },
      { w: "warm.", r: "ウォーム" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "like", r: "ライク", s: true },
      { w: "the", r: "ザ" },
      { w: "piano", r: "ピアノ" },
      { w: "is", r: "イズ" },
      { w: "breathing", r: "ブリージング", s: true },
      { w: "again.", r: "アゲイン" , s: true},
      { w: "I", r: "アイ" },
      { w: "open", r: "オープン", s: true },
      { w: "the", r: "ザ" },
      { w: "door.", r: "ドア" , s: true},
      { w: "Aya", r: "アヤ" },
      { w: "is", r: "イズ" },
      { w: "playing", r: "プレイング", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "sunset", r: "サンセット" },
      { w: "light.", r: "ライト" , s: true},
    ],
    en: "One evening, I hear a sound from the music room. It is the old piano. But the sound is warm. It is like the piano is breathing again. I open the door. Aya is playing in the sunset light.",
    ja: "ある夕暮れ、音楽室から音が聞こえました。\nあの古いピアノです。でも、その音は温かいものでした。\nまるでピアノが再び呼吸をしているようでした。\nドアを開けると、夕陽の中でアヤがピアノを弾いていました。",
    learning: {
      vocab: [
        { word: "resurrected", mean: "蘇った" },
        { word: "breathe", mean: "呼吸する" },
        { word: "sunset", mean: "夕焼け" },
      ],
      grammar: {
        title: "It is like + 文",
        desc: "「まるで～のようだ」と比喩（例え）を表す表現です。",
        key: "It is like the piano is breathing...",
      },
    },
    color: "bg-orange-100",
    accent: "text-orange-600",
    mood: { rate: 0.95, pitch: 1.0 },
    image: "images/001/03.jpg",
    startTime: 40,
  },
  {
    title: "Part 4: Feeling the Vibration",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "ask,", r: "アスク", s: true },
      { w: "'Why", r: "ホワイ" },
      { w: "does", r: "ダズ" },
      { w: "it", r: "イット" },
      { w: "sound", r: "サウンド", s: true },
      { w: "so", r: "ソー" },
      { w: "good?'", r: "グッド" , s: true},
      { w: "She", r: "シー" },
      { w: "touches", r: "タッチズ" },
      { w: "the", r: "ザ" },
      { w: "piano", r: "ピアノ", s: true },
      { w: "lovingly.", r: "ラビングリー" , s: true},
      { w: "'It", r: "イット" },
      { w: "is", r: "イズ", s: true },
      { w: "my", r: "マイ" },
      { w: "old", r: "オールド" },
      { w: "friend,'", r: "フレンド", s: true },
      { w: "she", r: "シー" },
      { w: "says.", r: "セイズ" , s: true},
      { w: "She", r: "シー" },
      { w: "smiles", r: "スマイルズ", s: true },
      { w: "a", r: "ア" },
      { w: "little.", r: "リトル" , s: true},
      { w: "'I", r: "アイ" },
      { w: "cannot", r: "キャノット" },
      { w: "hear.", r: "ヒア" , s: true},
      { w: "But", r: "バット", s: true },
      { w: "I", r: "アイ" },
      { w: "feel", r: "フィール", s: true },
      { w: "the", r: "ザ" },
      { w: "vibration.'", r: "バイブレーション", s: true },
      { w: "She", r: "シー" },
      { w: "touches", r: "タッチズ" },
      { w: "the", r: "ザ" },
      { w: "sound", r: "サウンド", s: true },
      { w: "with", r: "ウィズ" },
      { w: "her", r: "ハー" },
      { w: "fingers.", r: "フィンガーズ" , s: true},
    ],
    en: "I ask, 'Why does it sound so good?' She touches the piano lovingly. 'It is my old friend,' she says. She smiles a little. 'I cannot hear. But I feel the vibration.' She touches the sound with her fingers.",
    ja: "僕は尋ねました。「どうしてそんなにいい音がするの？」\n彼女は愛おしそうにピアノに触れました。\n「この子は、古い友達なの」と彼女は言います。\n少し微笑んで、「私、耳が聞こえないの。でも、振動を感じるわ」\n彼女は指先で音に触れていたのです。",
    learning: {
      vocab: [
        { word: "lovingly", mean: "愛おしそうに" },
        { word: "vibration", mean: "振動" },
        { word: "finger", mean: "指" },
      ],
      grammar: {
        title: "一般動詞 sound",
        desc: "「～のように聞こえる」という意味の動詞です。",
        key: "Why does it sound so good?",
      },
    },
    color: "bg-rose-50",
    accent: "text-rose-600",
    mood: { rate: 0.9, pitch: 1.0 },
    image: "images/001/04.jpg",
    startTime: 60,
  },
  {
    title: "Part 5: An Invisible Thread",
    rubyText: [
      { w: "We", r: "ウィ" },
      { w: "spend", r: "スペンド" },
      { w: "time", r: "タイム", s: true },
      { w: "together", r: "トゥゲザー", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "music", r: "ミュージック" },
      { w: "room.", r: "ルーム" , s: true},
      { w: "She", r: "シー" },
      { w: "teaches", r: "ティーチズ" },
      { w: "me", r: "ミー", s: true },
      { w: "how", r: "ハウ" },
      { w: "to", r: "トゥ" },
      { w: "touch", r: "タッチ", s: true },
      { w: "the", r: "ザ" },
      { w: "sound.", r: "サウンド" , s: true},
      { w: "'Feel", r: "フィール", s: true },
      { w: "the", r: "ザ" },
      { w: "vibration", r: "バイブレーション", s: true },
      { w: "with", r: "ウィズ" },
      { w: "your", r: "ユア" },
      { w: "bones.'", r: "ボーンズ" , s: true},
      { w: "When", r: "ウェン" },
      { w: "I", r: "アイ" },
      { w: "play,", r: "プレイ", s: true },
      { w: "she", r: "シー" },
      { w: "nods", r: "ノッズ", s: true },
      { w: "softly.", r: "ソフトリー" , s: true},
      { w: "We", r: "ウィ" },
      { w: "are", r: "アー" },
      { w: "connected", r: "コネクテッド", s: true },
      { w: "by", r: "バイ" },
      { w: "an", r: "アン" },
      { w: "invisible", r: "インビジブル" },
      { w: "thread", r: "スレッド", s: true },
      { w: "of", r: "オブ" },
      { w: "music.", r: "ミュージック" , s: true},
    ],
    en: "We spend time together in the music room. She teaches me how to touch the sound. 'Feel the vibration with your bones.' When I play, she nods softly. We are connected by an invisible thread of music.",
    ja: "僕たちは音楽室で一緒に過ごしました。\n彼女は音の「触れ方」を教えてくれました。\n「骨で振動を感じて」\n僕が弾くと、彼女は優しく頷きます。\n僕たちは、音楽という見えない糸で繋がっていました。",
    learning: {
      vocab: [
        { word: "bone", mean: "骨" },
        { word: "nod", mean: "うなずく" },
        { word: "invisible", mean: "目に見えない" },
        { word: "thread", mean: "糸" },
      ],
      grammar: {
        title: "疑問詞 + to不定詞",
        desc: "how to ～ で「～のやり方」「どう～するか」という意味になります。",
        key: "how to touch the sound",
      },
    },
    color: "bg-indigo-50",
    accent: "text-indigo-600",
    mood: { rate: 0.95, pitch: 0.95 },
    image: "images/001/05.jpg",
    startTime: 80,
  },
  {
    title: "Part 6: The Song of Life",
    rubyText: [
      { w: "On", r: "オン" },
      { w: "the", r: "ザ" },
      { w: "day", r: "デイ" },
      { w: "of", r: "オブ" },
      { w: "the", r: "ザ" },
      { w: "school", r: "スクール" },
      { w: "festival,", r: "フェスティバル", s: true },
      { w: "the", r: "ザ" },
      { w: "piano", r: "ピアノ" },
      { w: "is", r: "イズ", s: true },
      { w: "on", r: "オン" },
      { w: "the", r: "ザ" },
      { w: "stage.", r: "ステージ" , s: true},
      { w: "Students", r: "スチューデンツ" },
      { w: "laugh.", r: "ラフ" , s: true},
      { w: "'That", r: "ザット" },
      { w: "piano", r: "ピアノ" },
      { w: "is", r: "イズ" },
      { w: "broken!'", r: "ブロークン" , s: true},
      { w: "Aya", r: "アヤ" },
      { w: "starts", r: "スターツ", s: true },
      { w: "to", r: "トゥ" },
      { w: "play.", r: "プレイ" , s: true},
      { w: "The", r: "ザ" },
      { w: "sound", r: "サウンド", s: true },
      { w: "changes", r: "チェンジズ", s: true },
      { w: "the", r: "ザ" },
      { w: "air.", r: "エア" , s: true},
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "like", r: "ライク", s: true },
      { w: "a", r: "ア" },
      { w: "cry,", r: "クライ", s: true },
      { w: "a", r: "ア" },
      { w: "prayer,", r: "プレイヤー", s: true },
      { w: "and", r: "アンド" },
      { w: "a", r: "ア" },
      { w: "song", r: "ソング" },
      { w: "of", r: "オブ" },
      { w: "life.", r: "ライフ" , s: true},
      { w: "Some", r: "サム" },
      { w: "students", r: "スチューデンツ" },
      { w: "cry.", r: "クライ" , s: true},
    ],
    en: "On the day of the school festival, the piano is on the stage. Students laugh. 'That piano is broken!' Aya starts to play. The sound changes the air. It is like a cry, a prayer, and a song of life. Some students cry.",
    ja: "文化祭の日、ピアノはステージの上にありました。\n生徒たちは笑います。「あのピアノは壊れてるぞ！」\nアヤが弾き始めると、音が空気を変えました。\nそれは叫びであり、祈りであり、命の歌のようでした。\n涙を流す生徒もいました。",
    learning: {
      vocab: [
        { word: "laugh", mean: "笑う" },
        { word: "prayer", mean: "祈り" },
        { word: "life", mean: "命、人生" },
      ],
      grammar: {
        title: "start to ～",
        desc: "「～し始める」という意味です。",
        key: "Aya starts to play.",
      },
    },
    color: "bg-amber-100",
    accent: "text-amber-600",
    mood: { rate: 1.0, pitch: 1.05 },
    image: "images/001/06.jpg",
    startTime: 100,
  },
  {
    title: "Part 7: The Last Smile",
    rubyText: [
      { w: "After", r: "アフター" },
      { w: "the", r: "ザ" },
      { w: "festival,", r: "フェスティバル", s: true },
      { w: "I", r: "アイ" },
      { w: "speak", r: "スピーク", s: true },
      { w: "to", r: "トゥ" },
      { w: "her", r: "ハー", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "hallway.", r: "ホールウェイ" , s: true},
      { w: "'Aya...", r: "アヤ" , s: true},
      { w: "where", r: "ホエア" },
      { w: "are", r: "アー" },
      { w: "you", r: "ユー" },
      { w: "from?'", r: "フロム" , s: true},
      { w: "She", r: "シー" },
      { w: "does", r: "ダズ" },
      { w: "not", r: "ノット" },
      { w: "answer.", r: "アンサー" , s: true},
      { w: "She", r: "シー" },
      { w: "just", r: "ジャスト" },
      { w: "smiles", r: "スマイルズ", s: true },
      { w: "kindly.", r: "カインドリー" , s: true},
      { w: "That", r: "ザット" },
      { w: "is", r: "イズ", s: true },
      { w: "the", r: "ザ" },
      { w: "last", r: "ラスト" },
      { w: "time", r: "タイム", s: true },
      { w: "I", r: "アイ" },
      { w: "see", r: "シー" },
      { w: "her.", r: "ハー" , s: true},
      { w: "The", r: "ザ" },
      { w: "next", r: "ネクスト" },
      { w: "week,", r: "ウィーク", s: true },
      { w: "she", r: "シー" },
      { w: "moves", r: "ムーブス" },
      { w: "away.", r: "アウェイ" , s: true},
    ],
    en: "After the festival, I speak to her in the hallway. 'Aya... where are you from?' She does not answer. She just smiles kindly. That is the last time I see her. The next week, she moves away.",
    ja: "文化祭の後、僕は廊下で彼女に話しかけました。\n「アヤ……君はどこから来たの？」\n彼女は答えません。ただ優しく微笑みました。\nそれが彼女を見た最後でした。\n翌週、彼女は引っ越してしまいました。",
    learning: {
      vocab: [
        { word: "hallway", mean: "廊下" },
        { word: "kindly", mean: "優しく" },
        { word: "last time", mean: "最後" },
      ],
      grammar: {
        title: "関係副詞の省略",
        desc: "「私が彼女を見た最後」という意味で、timeの後に関係詞が省略されています。",
        key: "That is the last time I see her.",
      },
    },
    color: "bg-purple-100",
    accent: "text-purple-600",
    mood: { rate: 0.9, pitch: 0.9 },
    image: "images/001/07.jpg",
    startTime: 120,
  },
  {
    title: "Part 8: Beyond the Silence",
    rubyText: [
      { w: "Now,", r: "ナウ", s: true },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "music", r: "ミュージック" },
      { w: "room", r: "ルーム", s: true },
      { w: "alone.", r: "アローン" , s: true},
      { w: "I", r: "アイ" },
      { w: "play", r: "プレイ", s: true },
      { w: "the", r: "ザ" },
      { w: "piano.", r: "ピアノ" , s: true},
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "not", r: "ノット" },
      { w: "good,", r: "グッド", s: true },
      { w: "but", r: "バット", s: true },
      { w: "I", r: "アイ" },
      { w: "feel", r: "フィール", s: true },
      { w: "her", r: "ハー", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "vibration.", r: "バイブレーション", s: true },
      { w: "The", r: "ザ" },
      { w: "sound", r: "サウンド", s: true },
      { w: "melts", r: "メルツ", s: true },
      { w: "into", r: "イントゥ" },
      { w: "the", r: "ザ" },
      { w: "sunset.", r: "サンセット" , s: true},
      { w: "Music", r: "ミュージック" },
      { w: "connects", r: "コネクツ" },
      { w: "us", r: "アス", s: true },
      { w: "forever,", r: "フォーエバー", s: true },
      { w: "beyond", r: "ビヨンド" },
      { w: "time", r: "タイム", s: true },
      { w: "and", r: "アンド" },
      { w: "silence.", r: "サイレンス" , s: true},
    ],
    en: "Now, I am in the music room alone. I play the piano. I am not good, but I feel her in the vibration. The sound melts into the sunset. Music connects us forever, beyond time and silence.",
    ja: "今、僕は一人で音楽室にいます。\n僕はピアノを弾きます。上手ではありませんが、振動の中に彼女を感じます。\n音は夕陽に溶けていきます。\n音楽は、時間と沈黙を越えて、僕たちを永遠につないでいます。",
    learning: {
      vocab: [
        { word: "melt", mean: "溶ける" },
        { word: "beyond", mean: "～を越えて" },
        { word: "silence", mean: "沈黙" },
      ],
      grammar: {
        title: "beyond + 名詞",
        desc: "「～の向こう側に」「～を越えて」という空間や時間を超える意味を表します。",
        key: "beyond time and silence.",
      },
    },
    color: "bg-emerald-100",
    accent: "text-emerald-600",
    mood: { rate: 0.9, pitch: 1.0 },
    image: "images/001/08.jpg",
    startTime: 140,
  },
];

const QUIZ_POOL = [
  {
    q: "Where is the old piano?",
    options: [
      "In the gym",
      "In the graveyard of time (music room)",
      "In the garden",
    ],
    a: 1,
    exp: "Part 1で「音楽室は時間の墓場のようだ」とあり、そこにピアノがあります。",
  },
  {
    q: "What is Aya like?",
    options: [
      "She is loud",
      "She is quiet and looks at the sky",
      "She plays soccer",
    ],
    a: 1,
    exp: "Part 2で「とても静かで、いつも空を見ている」と紹介されています。",
  },
  {
    q: "What does the boy see around Aya?",
    options: ["A dog", "A transparent wall", "A lot of friends"],
    a: 1,
    exp: "Part 2で「透明な壁（transparent wall）」があると表現されています。",
  },
  {
    q: "How was the sound in Part 3?",
    options: ["Broken and bad", "Warm and like breathing", "Cold and scary"],
    a: 1,
    exp: "Part 3で「温かく、呼吸をしているようだ」とあります。",
  },
  {
    q: "Why can Aya play the piano so well?",
    options: [
      "She listens with her ears",
      "She feels the vibration",
      "She reads books",
    ],
    a: 1,
    exp: "Part 4で「耳は聞こえないが、振動を感じる」と言っています。",
  },
  {
    q: "How does Aya teach the boy?",
    options: ["Feel with bones", "Read the music sheet", "Hit the keys hard"],
    a: 0,
    exp: "Part 5で「骨で振動を感じて」と教えています。",
  },
  {
    q: "What happened at the school festival?",
    options: [
      "Everyone slept",
      "The sound changed the air and people cried",
      "The piano broke",
    ],
    a: 1,
    exp: "Part 6で「音が空気を変え、泣く生徒もいた」とあります。",
  },
  {
    q: "What did Aya do when the boy asked where she was from?",
    options: ["She answered", "She cried", "She just smiled"],
    a: 2,
    exp: "Part 7で「答えずに、ただ微笑んだ」とあります。",
  },
  {
    q: "What connects the boy and Aya forever?",
    options: ["The internet", "Music", "The teacher"],
    a: 1,
    exp: "Part 8で「音楽が永遠につないでいる」と結ばれています。",
  },
  {
    q: "What did teachers say about the piano?",
    options: [
      "They will sell it",
      "They will throw it away soon",
      "They will fix it",
    ],
    a: 1,
    exp: "Part 1で「先生たちは、もうすぐ処分する（throw it away）と言っている」とあります。",
  },
  {
    q: "What season did Aya arrive?",
    options: ["Spring", "Summer", "Autumn"],
    a: 2,
    exp: "Part 2で「In autumn, a new student comes.」と記述されています。",
  },
  {
    q: "What does Aya always look at?",
    options: ["The ground", "The sky", "The blackboard"],
    a: 1,
    exp: "Part 2で「She always looks at the sky alone.」とあります。",
  },
  {
    q: "What time of day did the narrator hear the sound in Part 3?",
    options: ["One morning", "One evening", "At midnight"],
    a: 1,
    exp: "Part 3の冒頭に「One evening（ある夕暮れ）」と書かれています。",
  },
  {
    q: "What did students do when they saw the piano on stage?",
    options: ["They laughed", "They clapped", "They left"],
    a: 0,
    exp: "Part 6で「Students laugh.（生徒たちは笑った）」とあります。",
  },
  {
    q: "What was on the piano in the beginning?",
    options: ["Books", "Flowers", "Dust"],
    a: 2,
    exp: "Part 1で「It is covered with dust.」とあります。",
  },
];

const SCRAMBLE_POOL = [
  {
    q: "音楽室は時間の墓場のようです。",
    w: ["The", "music", "room", "is", "like", "a", "graveyard", "of", "time"],
    o: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    q: "彼女はいつも一人で空を見ています。",
    w: ["She", "always", "looks", "at", "the", "sky", "alone"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "まるでピアノが呼吸しているようです。",
    w: ["It", "is", "like", "the", "piano", "is", "breathing"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "私は振動を感じます。",
    w: ["I", "feel", "the", "vibration"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼女は私に音の触れ方を教えます。",
    w: ["She", "teaches", "me", "how", "to", "touch", "the", "sound"],
    o: [0, 1, 2, 3, 4, 5, 6, 7],
  },
  {
    q: "音楽が私たちを永遠につなぎます。",
    w: ["Music", "connects", "us", "forever"],
    o: [0, 1, 2, 3],
  },
  {
    q: "その音は夕陽に溶けていきます。",
    w: ["The", "sound", "melts", "into", "the", "sunset"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "隅には古いピアノが置かれています。",
    w: ["In", "the", "corner", "there", "is", "an", "old", "piano"],
    o: [0, 1, 2, 3, 4, 5, 6, 7],
  },
  {
    q: "それは埃に覆われています。",
    w: ["It", "is", "covered", "with", "dust"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "私は情熱を持っていません。",
    w: ["I", "have", "no", "passion"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼女の周りには透明な壁があります。",
    w: ["There", "is", "a", "transparent", "wall", "around", "her"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "誰も彼女に触れません。",
    w: ["No", "one", "touches", "her"],
    o: [0, 1, 2, 3],
  },
  {
    q: "私はドアを開けます。",
    w: ["I", "open", "the", "door"],
    o: [0, 1, 2, 3],
  },
  {
    q: "それは私の古い友達なの、と彼女は言います。",
    w: ["It", "is", "my", "old", "friend", "she", "says"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "彼女は少し微笑みます。",
    w: ["She", "smiles", "a", "little"],
    o: [0, 1, 2, 3],
  },
];

const FILL_IN_THE_BLANK_POOL = [
  {
    q: "The music room is ------- a graveyard of time.",
    options: ["as", "like", "for", "to"],
    a: 1,
    exp: "「～のような」を表す前置詞は like です。",
  },
  {
    q: "There ------- a transparent wall around her.",
    options: ["is", "are", "be", "being"],
    a: 0,
    exp: "wall（壁）は単数形なので is が正解です。",
  },
  {
    q: "She teaches me ------- to touch the sound.",
    options: ["what", "which", "how", "why"],
    a: 2,
    exp: "「～のやり方」は how to ～ で表します。",
  },
  {
    q: "The sound ------- into the sunset.",
    options: ["melts", "melting", "melt", "to melt"],
    a: 0,
    exp: "主語 The sound が単数で、現在の話なので三単現のsがついた melts が正解です。",
  },
  {
    q: "Music connects us forever, ------- time and silence.",
    options: ["beyond", "over", "above", "through"],
    a: 0,
    exp: "「～を越えて」という空間・時間を超えるニュアンスは beyond です。",
  },
  {
    q: "The piano was covered ------- dust.",
    options: ["by", "at", "with", "of"],
    a: 2,
    exp: "「～で覆われている」は be covered with ～ です。",
  },
  {
    q: "I have no -------. I just live day by day.",
    options: ["passion", "fashion", "mission", "session"],
    a: 0,
    exp: "物語の文脈から「情熱（passion）」が入ります。",
  },
  {
    q: "The boy ------- watched her learned to feel the sound.",
    options: ["who", "which", "whose", "whom"],
    a: 0,
    exp: "「彼女を見ていた少年」という関係代名詞の主格 who が入ります。",
  },
  {
    q: "They will throw it ------- soon.",
    options: ["away", "off", "out", "up"],
    a: 0,
    exp: "「捨てる」は throw away です。",
  },
  {
    q: "She always looks ------- the sky.",
    options: ["to", "at", "on", "for"],
    a: 1,
    exp: "「～を見る」は look at です。",
  },
  {
    q: "The air around her is always -------.",
    options: ["calm", "calms", "calming", "calmed"],
    a: 0,
    exp: "「穏やかな」という形容詞 calm が入ります。",
  },
  {
    q: "It is like the piano is ------- again.",
    options: ["breathe", "breathing", "breath", "breathed"],
    a: 1,
    exp: "「呼吸している」という進行形の breathing が適切です。",
  },
  {
    q: "I feel her ------- the vibration.",
    options: ["on", "at", "in", "to"],
    a: 2,
    exp: "「振動の中に」なので in the vibration です。",
  },
  {
    q: "She does not -------.",
    options: ["answer", "answers", "answering", "answered"],
    a: 0,
    exp: "助動詞 does not の後は動詞の原形 answer が来ます。",
  },
  {
    q: "That is the ------- time I see her.",
    options: ["last", "end", "final", "finish"],
    a: 0,
    exp: "「最後」という意味で last time が自然です。",
  },
];

// export default するオブジェクト
export default {
  id: "Bu9FazwK",
  title: "The Silent Piano",
  level: "LEVEL 4",
  category: "Drama",
  content: STORY_DATA,
  quizzes: QUIZ_POOL,
  puzzles: SCRAMBLE_POOL,
  fills: FILL_IN_THE_BLANK_POOL,
};


